<template>
  <div class="hot-search">
    <div class="main-info">
      <span class="label">热门搜索：</span>
      <draggable
        :list="list"
        :disabled="!enabled"
        class="list-group iblock"
        ghost-class="ghost"
        :move="checkMove"
        @start="dragging = true"
        @end="dragging = false"
      >
        <div class="iblock option-item" v-for="(element,index) in list" :key="index">
          <el-button type="primary" round>{{ element }}</el-button>
          <i class="el-icon-close ml10" @click="removeItem(index)"></i>
        </div>
      </draggable>
    </div>
    <div class="main-info">
      <span class="label">添加词汇：</span>
      <el-input v-model="form.name" class="w300" v-on:keyup.enter.native="addItem" placeholder="请填写选项"></el-input>
      <span class="ml20">按回车生成，添加词汇优先展示</span>
    </div>

    <el-row style="padding-left:100px;">
      <el-button type="primary" @click="addHotSeach()">确认添加</el-button>
    </el-row>
  </div>
</template>

<script>
import draggable from "vuedraggable";

import {_hotSeachIndex,_hotSeachSave} from "@/api/interface";

import qs from 'qs'
import { stringify } from 'querystring';

export default {
  created(){
    this.hotSeachIndex();
  },
  components: {
    draggable
  },
  data() {
    return {
      enabled: true,
      form: {
        name: ""
      },
      list: [{ name: "我是张三" }, { name: "我是李四" }, { name: "我是王五" }],
      dragging: false
    };
  },
  computed: {
    draggingInfo() {
      return this.dragging ? "正在拖动" : "暂未拖动";
    }
  },
  methods: {
    add: function() {
      this.list.push({ name: "Juan " + id, id: id++ });
    },
    checkMove: function(e) {
      console.log(e.draggedContext);
      window.console.log("Future index: " + e.draggedContext.futureIndex);
    },
    addItem() {
      this.list.unshift(this.form.name);
    },
    removeItem(index){
        this.list.splice(index,1);
        // console.table(this.list);
    },
    // 获取热门搜索
    hotSeachIndex() {
      _hotSeachIndex({
        params: {
        }
      }).then(res => {
        if (res.resultCode == 1) {
          this.list = res.result;
        } else {
          this.$message.error(res.errorMsg);
        }
      });
    },
    //确定添加热门搜索
    addHotSeach() {
      _hotSeachSave({
        data: qs.stringify({
          content:this.list
        })
      }).then(res => {
        if (res.resultCode == 1) {
          this.$message.success(res.errorMsg);
          this.hotSeachIndex();
          this.form.name="";
        } else {
          this.$message.error(res.errorMsg);
        }
      });
    },
  }
};
</script>
<style scoped lang="less">
.hot-search {
  padding: 20px;
  .main-info {
    margin-bottom: 40px;
    .label {
      margin-right: 20px;
    }
  }
  .option-item {
    margin-right: 20px;
  }
}
</style>